import { addItemToUniqueArray, deleteItemFromArray } from '../../../../../../shared/utils/array';

export function toggleObjectInclusion(
  inclusionArray: string[] | undefined,
  exclusionArray: string[] | undefined,
  objectID: string,
  included: boolean
): { inclusions: string[]; exclusions: string[] } {
  if (included) {
    /**
     * When object is toggle to active state,
     * add this object to inclusion array and
     * remove from exclusion list if present
     * */
    return {
      inclusions: addItemToUniqueArray<string>(
        inclusionArray,
        objectID,
        (existingObjId, newObjId) => existingObjId === newObjId
      ),
      exclusions: deleteItemFromArray<string>(exclusionArray, item => item === objectID)
    };
  }

  /**
   * When object is toggle to in-active state,
   * add this object to exclusion array and
   * remove from inclusion list if present
   * */
  return {
    inclusions: deleteItemFromArray<string>(inclusionArray, item => item === objectID),
    exclusions: addItemToUniqueArray<string>(
      exclusionArray,
      objectID,
      (existingObjId, newObjId) => existingObjId === newObjId
    )
  };
}
